import { render } from "./CustomizableCorner.vue?vue&type=template&id=2f955b27"
import script from "./CustomizableCorner.vue?vue&type=script&lang=js"
export * from "./CustomizableCorner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__